import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import AntdTable from "src/components/AntdTable/Table"
import {
  deleteAbonement,
  getAbonementsList,
  getAbonementsListClubs,
} from "src/store/Slices/AbonementsSlice"
import AddNewAbonement from "../Modals/AddNewAbonement"
import { openNotification } from "src/components/helpers/notification"
import { useEffect } from "react"
import { Button, Dropdown, Input, Space, Switch } from "antd"
import { DownOutlined, UpOutlined } from "@ant-design/icons"
import SureModal from "src/components/Modals/SureModal"
import { SearchOutlined } from "@ant-design/icons"
import { useRef } from "react"
import EditNewAbonement from "../Modals/EditNewAbonement"
import { DeleteOutlined } from "@ant-design/icons"
import ChangeOrderModal from "../Modals/ChangeOrderModal"

const AbonementsGuide = ({
  abonementInfo,
  setAbonementInfo,
  mnemo,
}) => {
  // HELPERS
  const dispatch = useDispatch()

  // STATE
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isDeleted, setIsDeleted] = useState(false)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
  const [isOpenEditModal, setIsEditOpenModal] = useState(false)
  const [selectedKeys, setSelectedKyes] = useState("")
  const [dataIndex, setDataIndex] = useState("")
  const [sortByIdFrom, setSortByIdFrom] = useState()
  const [sortByIdTo, setSortByIdTo] = useState()
  const [keys, setKeys] = useState()
  const [isChangeOrder, setIsChangeOrder] = useState(false)
  const [totalCount, setTotalCount] = useState()

  // REF
  const searchInput = useRef(null)

  // STORE
  const abonementsList = useSelector(
    (state) => state.AbonementsSlice.abonementsList
  )
  const abonementsListLoading = useSelector(
    (state) => state.AbonementsSlice.abonementsListLoading
  )

  const getMenuItems = (record) => {
    const isSystem = record?.name === "SYSTEM"
    
    if (isSystem) {
      return [
        {
          key: "2",
          label: "Удалить",
          onClick: () => {
            setAbonementInfo(record)
            setIsOpenDeleteModal(true)
          },
          disabled: !mnemo?.children
            ?.find((el) => el.name === "Справочник")
            ?.children.find((ele) => ele.mnemo === "deleteBtn"),
        },
      ]
    } else {
      return [
        {
          key: "1",
          label: "Редактировать",
          onClick: () => {
            setAbonementInfo(record)
            setIsEditOpenModal(true)
          },
          disabled: !mnemo?.children
            ?.find((el) => el.name === "Справочник")
            ?.children.find((ele) => ele.mnemo === "updateBtn"),
        },
        {
          key: "2",
          label: "Удалить",
          onClick: () => {
            setAbonementInfo(record)
            setIsOpenDeleteModal(true)
          },
          disabled: !mnemo?.children
            ?.find((el) => el.name === "Справочник")
            ?.children.find((ele) => ele.mnemo === "deleteBtn"),
        },
      ]
    }
  }

  const title = () => {
    return (
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          marginBottom: 0,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#fff",
            userSelect: "none",
            minHeight: "60px",
            padding: "0 16px",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <CNav variant='tabs'>
              <CNavItem>
                <CNavLink
                  style={{
                    fontWeight: 500,
                    borderRadius: "6px 6px 0 0",
                    cursor: "pointer",
                  }}
                  active={true}
                >
                  Справочник абонементов
                </CNavLink>
              </CNavItem>
            </CNav>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <CButton
                size='sm'
                className='text-light'
                style={{
                  height: "34px",
                  minWidth: "100px",
                  fontSize: "15px",
                  fontWeight: "500",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                }}
                onClick={() => setIsChangeOrder(!isChangeOrder)}
              >
                Изменить порядок
              </CButton>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginLeft: "20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Switch
                disabled={
                  !mnemo?.children
                    ?.find((el) => el.name === "Справочник")
                    ?.children.find((ele) => ele.mnemo === "isDeletedBtn")
                }
                defaultValue={isDeleted}
                checkedChildren={<DeleteOutlined />}
                unCheckedChildren={<DeleteOutlined />}
                onChange={() => {
                  setIsDeleted(!isDeleted)
                }}
                style={{ transform: "scale(1.1)" }}
              />
              
              {!isDeleted && (
                <CButton
                  disabled={
                    !mnemo?.children
                      ?.find((el) => el.name === "Справочник")
                      ?.children.find((ele) => ele.mnemo === "insertBtn")
                  }
                  size='sm'
                  className='text-light'
                  style={{
                    height: "34px",
                    minWidth: "100px",
                    fontSize: "15px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                  }}
                  onClick={() => setIsOpenModal(true)}
                >
                  Добавить
                </CButton>
              )}
            </div>
            
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "40px",
              }}
            >
              <Button
                type='text'
                icon={<DownOutlined />}
                style={{
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                  color: "#8c8c8c",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
  const handleReset = (clearFilters) => {
    setPage(1)
    setPageSize(20)
    dispatch(getAbonementsList())
    setSelectedKyes()
    setDataIndex()
    clearFilters()
    setSortByIdFrom()
    setSortByIdTo()
  }

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1)
    setPageSize(20)
    setSelectedKyes(selectedKeys[0])
    setDataIndex(dataIndex)
    dispatch(
      getAbonementsList({
        isDeleted: isDeleted,
        [`${dataIndex}`]: selectedKeys[0],
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
      })
    )
  }

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div>
          {title !== "№" && (
            <Input
              ref={searchInput}
              placeholder={`Искать ${title}`}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => onClickSearchItem(selectedKeys, dataIndex)}
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
          )}
          {title === "№" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
              <Input
                placeholder='От'
                type='number'
                value={sortByIdFrom}
                onChange={(e) => setSortByIdFrom(e.currentTarget.value)}
              />
              <Input
                placeholder='До'
                type='number'
                value={sortByIdTo}
                onChange={(e) => setSortByIdTo(e.currentTarget.value)}
              />
            </div>
          )}
        </div>
        <Space>
          <Button
            type='primary'
            onClick={() => onClickSearchItem(selectedKeys, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Искать
          </Button>
          <Button
            onClick={() => {
              if (clearFilters) {
                handleReset(clearFilters)
              }
            }}
            size='small'
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close()
            }}
          >
            Закрыть
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) => text,
  })

  const onClickRowOne = (record) => {
    setAbonementInfo(record)
    // Добавляем проверку на наличие record.id
    if (record?.id) {
      dispatch(getAbonementsListClubs({ AbonementId: record.id }))
    }
  }

  const rowClassName = (record) => {
    return record?.key === abonementInfo?.key ? "selected-row" : ""
  }

  const onClickDelete = () => {
    // Проверяем, что abonementInfo существует и имеет id
    if (!abonementInfo?.id) {
      openNotification({
        type: 'error',
        message: 'Не выбран абонемент для удаления'
      })
      return
    }
    
    dispatch(
      deleteAbonement({
        abonementId: abonementInfo.id,
      })
    ).then(() => {
      dispatch(getAbonementsList())
      setIsOpenDeleteModal(false)
    })
  }

  const handleTableChange = (pagination, filters, sorter) => {
    dispatch(
      getAbonementsList({
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        isDeleted: isDeleted,
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
        [`${dataIndex}`]: selectedKeys && selectedKeys[0],
      })
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  useEffect(() => {
    dispatch(
      getAbonementsList({
        count: pageSize,
        offset: pageSize * (page - 1),
        isDeleted: isDeleted,
        [`${dataIndex}`]: selectedKeys && selectedKeys[0],
        idFrom: sortByIdFrom,
        idTo: sortByIdTo,
      })
    )
  }, [isDeleted])

  return (
    <>
      <AddNewAbonement visible={isOpenModal} setVisible={setIsOpenModal} />
      <EditNewAbonement
        visible={isOpenEditModal}
        setVisible={setIsEditOpenModal}
        abonementInfo={abonementInfo}
      />
      <SureModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickYes={onClickDelete}
      />
      <ChangeOrderModal visible={isChangeOrder} setVisible={setIsChangeOrder} />
      <AntdTable
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        setPage={setPage}
        loading={abonementsListLoading}
        columns={
          abonementsList && [
            ...abonementsList?.data?.value?.columns.map((element) => {
              return {
                ...element,
                ...getColumnSearchProps(element.dataIndex, element.title),
              }
            }),
            {
              title: "Действия",
              key: "action",
              align: "center",
              render: (_, record) => {
                return (
                  <Dropdown
                    menu={{
                      items: getMenuItems(record),
                    }}
                    disabled={isDeleted}
                  >
                    <a className='text-primary text-decoration-none'>
                      Действия <DownOutlined />
                    </a>
                  </Dropdown>
                )
              },
              width: 100,
            },
          ]
        }
        rows={abonementsList?.data?.value?.rows}
        scroll={{ x: 0, y: 200 }}
        title={title}
        onClickRowOne={onClickRowOne}
        onChange={handleTableChange}
        total={abonementsList?.data?.value?.totalCount}
        rowClassName={rowClassName}
      />
    </>
  )
}

export default AbonementsGuide